import { CompanyDexie } from "../interfaces/companyDexie";

export async function getCompanyByTin(tin: string, thisCompanies): Promise<CompanyDexie | undefined> {
    const company = await thisCompanies.where('tin').equals(tin).first();
    if (!company) {
        console.error('Company not found');
        return;
    }
    return company
}